// extracted by mini-css-extract-plugin
export default {"Login":"Login_Login__KrjMy"};